import $ from 'jquery'
import FieldTypes from './../field-types'
import SingleLineText from './single-line-text'
import Email from './email'
import Paragraph from './paragraph'
import Dropdown from './dropdown'
import Checkboxes from './checkboxes'
import MultipleChoice from './multiple-choice'
import DateField from './date-field'
import State from './state'
import SectionBreak from './section-break'
import Phone from './phone'
import Logger from './../../common/logger'

const Factory = (($) => {

	class Factory {

		constructor(){

		}

		load(metaData){
			switch(parseInt(metaData.fieldTypeID)){
				case FieldTypes.SingleLineText:
					return new SingleLineText(metaData)
					break;
				case FieldTypes.Paragraph:
					return new Paragraph(metaData)
					break;
				case FieldTypes.Email:
					return new Email(metaData)
					break;
				case FieldTypes.Dropdown:
					return new Dropdown(metaData)
					break;
				case FieldTypes.MultipleChoice:
					return new MultipleChoice(metaData)
					break;
				case FieldTypes.Checkboxes:
					return new Checkboxes(metaData)
					break;
				case FieldTypes.State:
					return new State(metaData)
					break;
				case FieldTypes.SectionBreak:
					return new SectionBreak(metaData)
					break;
				case FieldTypes.DateInput:
					return new DateField(metaData)
					break;					
				case FieldTypes.Phone:
					return new Phone(metaData)
					break;
				default:
					Logger.warn("Field Type '" + metaData.fieldTypeID + "' is not supported.")
					break;

			}
		}
	}

	return new Factory()
})($)


export default Factory;
